import { Stack, TextField, useMediaQuery, useTheme } from "@mui/material";
import { Controller } from "react-hook-form";
import { Text } from "./Text";

type Props = {
  label: string;
  name: string;
  marginTop?: number;
  control: any;
  errors: any;
};

export const FormInput = ({
  label,
  name,
  marginTop,
  control,
  errors,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const inputStyle = {
    marginTop: 1,
    "& .MuiInputBase-root": {
      borderRadius: isMobile ? "15px" : "30px",
      borderColor: "#cccccc",
    },
  };

  return (
    <Stack>
      <Stack
        direction="row"
        gap={0.5}
        alignItems="flex-end"
        paddingLeft={1}
        marginTop={marginTop ? marginTop : isMobile ? 1.5 : 3.5}
      >
        <Text fontWeight={700}>{label}</Text>
        <Text color="#7e0000" fontWeight={700} lineHeight={2.2} fontSize={12}>
          ＊
        </Text>
      </Stack>
      <Controller
        name={name}
        control={control}
        rules={{
          required: `${label}は必須です`,
          ...(name === "email"
            ? {
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message:
                    "正しいメールアドレスを入力してください / Please enter a valid email address",
                },
              }
            : {}),
        }}
        render={({ field }) => (
          <TextField
            color="primary"
            {...field}
            variant="outlined"
            fullWidth
            error={!!errors[name]}
            helperText={
              errors[name]?.message ? String(errors[name]?.message) : ""
            }
            sx={inputStyle}
            {...(name === "message"
              ? {
                  multiline: true,
                  rows: 8,
                }
              : {})}
          />
        )}
      />
    </Stack>
  );
};
